import React from "react"

import { DeleteAddonOverlayView } from "./DeleteAddonOverlayView"
import { useDeleteAddonOverlayViewModel } from "./hooks/useDeleteAddonOverlayViewModel"

export interface DeleteAddonOverlayPayload {
  productType: string
  addonKey: string
  addonName?: string
  onDelete: () => void
}

export interface DeleteAddonOverlayProps {
  payload: DeleteAddonOverlayPayload
}

export const DeleteAddonOverlay = React.memo(
  (props: DeleteAddonOverlayProps) => (
    <DeleteAddonOverlayView {...useDeleteAddonOverlayViewModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DELETE_ADDON_OVERLAY: DeleteAddonOverlayPayload
  }
}
